import { useLoad } from "@allergy123/api-client/react";
import { Card, Status, Table, Td, Th } from "@allergy123/ui";

/** Monthly aggregate counts per assigned practice, only for months inside the assignment window. */
export function VolumePage() {
  const data = useLoad((a) => a.reps.volume());
  if (data.state === "error") return <Status kind="error" label={`Couldn't load practice volume (${data.error?.message})`} />;
  if (!data.data) return <p className="text-ink-secondary">Loading…</p>;
  const months = [...data.data.months].sort((a, b) => b.month.localeCompare(a.month) || a.name.localeCompare(b.name));
  const label = (m: string) => new Date(`${m}T00:00:00`).toLocaleDateString(undefined, { year: "numeric", month: "long" });
  return (
    <>
      <h1 className="mb-2 text-h1 font-semibold text-anchor">Practice volume</h1>
      <p className="mb-8 max-w-[68ch] text-ink-secondary">Tests performed and therapy orders placed, by practice and month. These are counts reported from the clinical system; no patient-level detail exists here.</p>
      <Card>
        <Table caption={months.length ? `${months.length} practice-month${months.length === 1 ? "" : "s"}` : "No activity reported yet"}>
          <thead>
            <tr>
              <Th>Month</Th>
              <Th>Practice</Th>
              <Th className="text-right">Tests</Th>
              <Th className="text-right">Therapy orders</Th>
              <Th>Source</Th>
            </tr>
          </thead>
          <tbody>
            {months.map((m) => (
              <tr key={m.month + m.organizationId}>
                <Td>{label(m.month)}</Td>
                <Td>{m.name}</Td>
                <Td className="text-right tabular-nums">{m.tests}</Td>
                <Td className="text-right tabular-nums">{m.therapyOrders}</Td>
                <Td className="text-small text-ink-secondary">{m.sourceSystem}</Td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Card>
    </>
  );
}
